import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIPS_BOOKING_SEARCH_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

/**
 * /trips/booking-search
 */
export class TripsBookingSearchController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trips.TripSearchBooking,U,80';
  public readonly path = '/trips/booking-search';
  public readonly routeName = 'trips-booking-search';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trips-booking-search" */ 'views/trips-booking-search-view')
  );

  public readonly pageName = 'page.Trips.TripSearchBooking';
  public readonly clickstreamPageName = 'Trip Search Booking';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIPS_BOOKING_SEARCH_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-booking-search-controller'
    });

    return Promise.resolve();
  }
}
